module.exports = __webpack_public_path__ + "img/Back Wing.539e46e5.png";